

class ParticipantDetails {

    private static instance: ParticipantDetails;

    public static getInstance(): ParticipantDetails {
        if (!ParticipantDetails.instance) {
            ParticipantDetails.instance = new ParticipantDetails();
        }
        return ParticipantDetails.instance;
    }

    _userDetails: any ;
    _sipParticipantDetails : any;
    _partnerDetails : any;
    _customerReferenceId : string;
    _callPurpose : string;

    public updateSipParticipantDetails(newSipParticipantDetails: any) {
        this._sipParticipantDetails = newSipParticipantDetails;
    }

    public getSipParticipantDetails() {
        return this._sipParticipantDetails || {};
    }

    public getPartnerDetails(){
        return this._partnerDetails || {};
    }

    public updatePartnerDetails(partnerDetails : any){
        this._partnerDetails = partnerDetails;
    }

    public updateUserDetails(newParticipantDetails: any) {
        this._userDetails = newParticipantDetails;
    }

    public getUserDetails() {
        return this._userDetails;
    }

    public getCustomerReferenceId(){
        return this._customerReferenceId;
    }

    public updateCustomerReferenceId(customerReferenceId : string){
        this._customerReferenceId = customerReferenceId;
    }

    public getCallPurpose(){
        return this._callPurpose;
    }

    public updateCallPurpose(callPurpose){
        this._callPurpose = callPurpose;
    }

    public updateParticipantDetails(participantDetails : any){
        if(participantDetails){
            this._sipParticipantDetails = participantDetails.sipParticipantDetails;
            this._userDetails = participantDetails.userDetails;
            this._partnerDetails = participantDetails.partnerDetails;
            this._customerReferenceId = participantDetails.customerReferenceId;
            this._callPurpose = participantDetails.callPurpose;
        }
    }

}

export {
    ParticipantDetails
}